import {
  IPublicClientApplication,
  InteractionRequiredAuthError,
  SilentRequest,
} from "@azure/msal-browser";
import { apiScopes } from "../config/auth";

let msalInstance: IPublicClientApplication | null = null;

export const accessTokenService = {
  initialize(instance: IPublicClientApplication) {
    msalInstance = instance;
  },

  async getAccessToken(scopes: string[] = apiScopes.access): Promise<string> {
    if (!msalInstance) {
      throw new Error("MSAL instance not initialized");
    }

    const accounts = msalInstance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No authenticated accounts found");
    }

    const request: SilentRequest = {
      scopes,
      account: accounts[0],
    };

    try {
      const response = await msalInstance.acquireTokenSilent(request);
      return response.accessToken;
    } catch (error) {
      if (error instanceof InteractionRequiredAuthError) {
        const response = await msalInstance.acquireTokenPopup(request);
        return response.accessToken;
      }
      throw error;
    }
  },
};
